import { render, staticRenderFns } from "./prove.vue?vue&type=template&id=c39205ee&scoped=true&"
import script from "./prove.vue?vue&type=script&lang=js&"
export * from "./prove.vue?vue&type=script&lang=js&"
import style0 from "./prove.vue?vue&type=style&index=0&id=c39205ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39205ee",
  null
  
)

export default component.exports